/**
 * Retries an API call at specified intervals until it succeeds or the maximum duration is reached.
 * @param {Function} apiFunction - API function to be called which return a Promise.
 * @param {Number} maxDuration - maximum time in milliseconds to keep retrying the API call.
 * @param {Number} interval - interval in milliseconds between the retries.
 * @param  {...any} args - arguments to be passed to the {apiFunction} on each call.
 * @returns {Promise<any>} - promise that resolves with the response of the API call when successful, or rejects
 */
export const retryApiCall = (apiFunction, maxDuration, interval, ...args) => {
  let startTime = Date.now(); // the start time at the first call

  return new Promise((resolve, reject) => {
    function attempt() {
      apiFunction(...args)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          let currentTime = Date.now();
          if (currentTime - startTime < maxDuration) {
            console.error(`API call failed, retrying in ${interval}...${error}`);
            setTimeout(attempt, interval);
          } else {
            reject(`API call failed after several attempts: ${error}`);
          }
        });
    }

    attempt(); // trigger the first attempt
  });
};
